import React, { useState, useEffect } from "react";

export default function PreviewNotes({
  onNext,
  MaintainanceData,
  MaintainanceData_prev,
  cardata,
}) {
  let data_set = MaintainanceData_prev;
  let car_data = cardata;

  if (MaintainanceData && MaintainanceData.tail_right) {
    data_set = MaintainanceData;
  }

  const [generalInfo, setGeneralInfo] = useState(
    data_set?.name_and_issue || ""
  );
  const [oilQuality, setoilQuality] = useState(data_set?.oil_quantity || "");
  const [inspectionNotes, setinspectionNotes] = useState(
    data_set?.inspectionnote || ""
  );
  const [remarksNotes, setremarksNotes] = useState(
    data_set?.remark_dashboard_code || ""
  );
  const [repairsNotes, setrepairsNotes] = useState(
    data_set?.details_for_repair || ""
  );
  const [futureNotes, setfutureNotes] = useState(
    data_set?.notes_for_future || ""
  );
  const [lightCheckData, setLightCheckData] = useState({
    tailLights: {
      right: data_set?.tail_right || "",
      left: data_set?.tail_left || "",
      reverseRight: data_set?.tail_reverse_right || "",
      reverseLeft: data_set?.tail_reverse_left || "",
      blinkerRight: data_set?.tail_binker_right || "",
      blinkerLeft: data_set?.tail_binker_left || "",
    },
    frontLights: {
      rightLow: data_set?.front_light_right_low || "",
      leftHigh: data_set?.front_light_left_high || "",
      rightHigh: data_set?.front_light_right_high || "",
      leftLow: data_set?.front_light_left_low || "",
      blinkerRight: data_set?.blinker_right || "",
      blinkerLeft: data_set?.blinker_left || "",
    },
  });
  const [tireTread, setTireTread] = useState({
    frontRight: data_set?.tire_trade_front_right || "",
    frontLeft: data_set?.tire_trade_front_left || "",
    rearLeft: data_set?.tire_trade_rear_left || "",
    rearRight: data_set?.tire_trade_rear_right || "",
  });
  const [tireAction, setTireAction] = useState(data_set?.tire || "");
  const [heatingAC, setheatingAC] = useState(data_set?.ac_check || "");
  const [additionalNotes, setAdditionalNotes] = useState(
    car_data?.last_maintenance_notes || ""
  );

  const handleNext = () => onNext();

  // ----- Helpers -----
  const isBlank = (v) => !v || String(v).trim() === "";
  const lc = (v) => String(v || "").toLowerCase();

  // --- Light logic (treat blank as skip) ---
  const skipKeywords = ["good", "need bulb"];
  const isSkipped = (v) =>
    isBlank(v) || skipKeywords.some((p) => lc(v).includes(p));

  const tailLightKeys = [
    "right",
    "left",
    "reverseRight",
    "reverseLeft",
    "blinkerRight",
    "blinkerLeft",
  ];
  const frontLightKeys = [
    "rightLow",
    "rightHigh",
    "leftLow",
    "leftHigh",
    "blinkerLeft",
    "blinkerRight",
  ];

  const allTailLightsSkipped = tailLightKeys.every((key) =>
    isSkipped(lightCheckData.tailLights[key])
  );
  const allFrontLightsSkipped = frontLightKeys.every((key) =>
    isSkipped(lightCheckData.frontLights[key])
  );

  const hideLightCheckingSection =
    allTailLightsSkipped && allFrontLightsSkipped;

  // --- Tire logic (treat blank as OK) ---
  const treadOkKeywords = [
    "100",
    "100%",
    "75",
    "75%",
    "50",
    "50%",
    "25",
    "25%",
  ];
  const isTreadOk = (v) =>
    isBlank(v) || treadOkKeywords.some((p) => String(v).includes(p));

  const allTiresOk = ["frontRight", "frontLeft", "rearLeft", "rearRight"].every(
    (key) => isTreadOk(tireTread[key])
  );

  const tireActionOk =
    isBlank(tireAction) ||
    lc(tireAction).includes("good") ||
    lc(tireAction).includes("change");

  const hideTireSection = allTiresOk && tireActionOk;

  // --- Car inspection (hide when blank OR "workinggood") ---
  const hideCarInspectionSection =
    isBlank(heatingAC) || lc(heatingAC).includes("workinggood");

  // --- Additional notes (hide when blank) ---
  const hideCarAdditionalNotes = isBlank(additionalNotes);

  // --- Oil section: only show when "changedNextTime" ---
  const showOilSection = oilQuality === "changedNextTime";

  // --- Final Checks section: show only if any has text ---
  const showFinalChecks = [
    inspectionNotes,
    remarksNotes,
    repairsNotes,
    futureNotes,
  ].some((v) => !isBlank(v));

  // --- No data available if EVERY possible section is hidden/blank ---
  const noDataAvailable =
    hideLightCheckingSection &&
    hideTireSection &&
    hideCarInspectionSection &&
    hideCarAdditionalNotes &&
    isBlank(generalInfo) &&
    !showOilSection &&
    !showFinalChecks;

  // Debug (optional)
  // console.log({ hideLightCheckingSection, hideTireSection, hideCarInspectionSection, hideCarAdditionalNotes, showOilSection, showFinalChecks, noDataAvailable });

  return (
    <div>
      <div className="preview_notes_main">
        <div className="preview-content">
          {noDataAvailable ? (
            <div className="no-notes-container">
              <div className="animation-wrapper">
                <div className="floating-circles">
                  <div className="circle circle-1"></div>
                  <div className="circle circle-2"></div>
                  <div className="circle circle-3"></div>
                  <div className="circle circle-4"></div>
                  <div className="circle circle-5"></div>
                </div>
                <div className="main-illustration">
                  <div className="notebook-icon">
                    <div className="notebook-cover">
                      <div className="notebook-lines">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                      </div>
                    </div>
                    <div className="notebook-shadow"></div>
                  </div>
                  <div className="search-icon">
                    <div className="magnifying-glass">
                      <div className="glass-circle"></div>
                      <div className="glass-handle"></div>
                    </div>
                  </div>
                </div>
                <div className="text-content">
                  <h2 className="main-title">No Notes Found</h2>
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* General Info */}
              {!isBlank(generalInfo) && (
                <div className="main-section">
                  <h3 className="section-title">General Info</h3>
                  <div className="subsection">
                    <div className="items-list">
                      <div className="list_item_show">
                        <span className="item-name">Issue with the car</span>
                        <span className="item-note">{generalInfo}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Additional Notes */}
              {!hideCarAdditionalNotes && (
                <div className="main-section">
                  <h3 className="section-title">Car Additional Notes</h3>
                  <div className="subsection">
                    <div className="items-list">
                      <div className="list_item_show">
                        <span className="item-note">{additionalNotes}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Light Checking Section */}
              {!hideLightCheckingSection && (
                <div className="main-section">
                  <h3 className="section-title">Light Checking</h3>

                  {/* Tail Lights */}
                  <div className="subsection">
                    <div className="subsection-header">
                      <span className="subsection-title">Tail Lights</span>
                      <span className="status-badge status-need-repair">
                        Need Repair
                      </span>
                    </div>
                    <div className="items-list">
                      {!isSkipped(lightCheckData.tailLights.right) && (
                        <div className="list_item_show">
                          <span className="item-name">Right</span>
                          <span className="item-note">
                            {lightCheckData.tailLights.right}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.tailLights.left) && (
                        <div className="list_item_show">
                          <span className="item-name">Left</span>
                          <span className="item-note">
                            {lightCheckData.tailLights.left}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.tailLights.reverseRight) && (
                        <div className="list_item_show">
                          <span className="item-name">Reverse Right</span>
                          <span className="item-note">
                            {lightCheckData.tailLights.reverseRight}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.tailLights.reverseLeft) && (
                        <div className="list_item_show">
                          <span className="item-name">Reverse Left</span>
                          <span className="item-note">
                            {lightCheckData.tailLights.reverseLeft}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.tailLights.blinkerRight) && (
                        <div className="list_item_show">
                          <span className="item-name">Blinker Right</span>
                          <span className="item-note">
                            {lightCheckData.tailLights.blinkerRight}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.tailLights.blinkerLeft) && (
                        <div className="list_item_show">
                          <span className="item-name">Blinker Left</span>
                          <span className="item-note">
                            {lightCheckData.tailLights.blinkerLeft}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Front Lights */}
                  <div className="subsection">
                    <div className="subsection-header">
                      <span className="subsection-title">Front Lights</span>
                      <span className="status-badge status-need-repair">
                        Need Repair
                      </span>
                    </div>
                    <div className="items-list">
                      {!isSkipped(lightCheckData.frontLights.rightLow) && (
                        <div className="list_item_show">
                          <span className="item-name">Right Low</span>
                          <span className="item-note">
                            {lightCheckData.frontLights.rightLow}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.frontLights.rightHigh) && (
                        <div className="list_item_show">
                          <span className="item-name">Right High</span>
                          <span className="item-note">
                            {lightCheckData.frontLights.rightHigh}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.frontLights.leftLow) && (
                        <div className="list_item_show">
                          <span className="item-name">Left Low</span>
                          <span className="item-note">
                            {lightCheckData.frontLights.leftLow}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.frontLights.leftHigh) && (
                        <div className="list_item_show">
                          <span className="item-name">Left High</span>
                          <span className="item-note">
                            {lightCheckData.frontLights.leftHigh}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.frontLights.blinkerLeft) && (
                        <div className="list_item_show">
                          <span className="item-name">Blinker Left</span>
                          <span className="item-note">
                            {lightCheckData.frontLights.blinkerLeft}
                          </span>
                        </div>
                      )}
                      {!isSkipped(lightCheckData.frontLights.blinkerRight) && (
                        <div className="list_item_show">
                          <span className="item-name">Blinker Right</span>
                          <span className="item-note">
                            {lightCheckData.frontLights.blinkerRight}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Oil Check */}
              {showOilSection && (
                <div className="main-section">
                  <h3 className="section-title">Oil Check</h3>
                  <div className="subsection">
                    <div className="items-list">
                      <div className="list_item_show">
                        <span className="item-name">Oil Quality</span>
                        <span className="item-note">Change Next Time</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Tire Inspection Section */}
              {!hideTireSection && (
                <div className="main-section">
                  <h3 className="section-title">Tire Inspection</h3>
                  <div className="subsection">
                    <div className="subsection-header">
                      <span className="subsection-title">Tread Depth</span>
                      <span className="status-badge status-need-repair">
                        Need Repair
                      </span>
                    </div>
                    <div className="items-list">
                      {["frontRight", "frontLeft", "rearLeft", "rearRight"].map(
                        (key) => {
                          if (isTreadOk(tireTread[key])) return null; // skip if ok/blank
                          return (
                            <div className="list_item_show" key={key}>
                              <span className="item-name">
                                {key.replace(/([A-Z])/g, " $1")}
                              </span>
                              <span className="item-note">
                                {tireTread[key]}
                              </span>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>

                  <div className="subsection">
                    <div className="subsection-header">
                      <span className="subsection-title">Tire Action</span>
                    </div>
                    {!tireActionOk && (
                      <div className="list_item_show">
                        <span className="item-note">{tireAction}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Car Inspection Section */}
              {!hideCarInspectionSection && (
                <div className="main-section">
                  <h3 className="section-title">Car Inspection</h3>
                  <div className="subsection">
                    <div className="subsection-header">
                      <span className="subsection-title">Heating/AC Check</span>
                      <span className="status-badge status-need-repair">
                        Need Repair
                      </span>
                    </div>
                    <div className="items-list">
                      {!lc(heatingAC).includes("workinggood") &&
                        !isBlank(heatingAC) && (
                          <div className="list_item_show">
                            <span className="item-note">{heatingAC}</span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              )}

              {/* Final Checks — only when any note has text */}
              {showFinalChecks && (
                <div className="main-section">
                  <h3 className="section-title">Final Checks</h3>
                  <div className="subsection">
                    <div className="items-list">
                      {!isBlank(inspectionNotes) && (
                        <div className="list_item_show">
                          <span className="item-name">Inspection Notes</span>
                          <span className="item-note">{inspectionNotes}</span>
                        </div>
                      )}
                      {!isBlank(remarksNotes) && (
                        <div className="list_item_show">
                          <span className="item-name">
                            Remarks For Dashboard
                          </span>
                          <span className="item-note">{remarksNotes}</span>
                        </div>
                      )}
                      {!isBlank(repairsNotes) && (
                        <div className="list_item_show">
                          <span className="item-name">Repairs Done</span>
                          <span className="item-note">{repairsNotes}</span>
                        </div>
                      )}
                      {!isBlank(futureNotes) && (
                        <div className="list_item_show">
                          <span className="item-name">Notes For Future</span>
                          <span className="item-note">{futureNotes}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="navigation-buttons">
        <button className="btn back-button firstbackBtn">Back</button>
        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
}
